import * as React from 'react';
import { colors } from '../../../index';

const IconDownOpen = ({
  className = '',
  size = '1em',
  color,
  style = {}
}) => {
  const finalStyle = { ...style,
    fill: colors[color],
    color: colors[color]
  };
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 64 37",
    width: size,
    height: size,
    style: finalStyle,
    className: `icon ${className}`
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M31.99 36.49a4.467 4.467 0 01-3.168-1.312L1.312 7.668A4.48 4.48 0 117.65 1.332l24.34 24.342L56.33 1.333a4.48 4.48 0 016.336 6.336L35.156 35.18a4.467 4.467 0 01-3.167 1.31z"
  }));
};

export default IconDownOpen;